// import type { Id } from 'flowTypes/common';
import { FORMULA_TYPES } from 'constants/all';

// import type { ProcessFinish } from 'modules/processes/data/entities';
import request from 'utils/request';
import { keysToSnakeCaseDeep } from 'utils/stringUtils';

// import type { Process } from './entities';

export default {
  getProcess: async (processId) => {
    return await request.get(`/processes/${processId}`);
  },

  updateProcessMaterials: async (processId, data) => {
    return await request.post(
      `/processes/${processId}/materials`,
      keysToSnakeCaseDeep(data),
    );
  },

  updateProcess: async (processId, data) => {
    return await request.patch(
      `/processes/${processId}`,
      keysToSnakeCaseDeep(data),
    );
  },

  createFinish: async (processId, finishIds) => {
    return await request.post(
      `/processes/${processId}/finishes`,
      finishIds.map((id) => ({ finish_id: id })),
    );
  },

  updateFinish: async (finishId, data) => {
    return await request.patch(
      `/processes/finishes/${finishId}`,
      keysToSnakeCaseDeep(data),
    );
  },

  deleteFinish: async (finishId) => {
    await request.delete(`/processes/finishes/${finishId}`);
  },

  deleteProcess: async (processId) => {
    await request.delete(`/processes/${processId}`);
  },

  updateProcessFormula: async ({ processId, formula, revertedFrom }) =>
    await request.post(`/suppliers/processes/${processId}/formula`, {
      formula,
      revertedFrom,
    }),

  compileFormula: async ({ processId, formula, supplierId }) =>
    await request.post('/formula/compile/v2', {
      formula,
      type: FORMULA_TYPES.PROCESS,
      processId,
      supplierId,
    }),
};
